import {pushHookEvent} from "./push-hook-event.js"
import {safeStorage} from "../safe-storage"

const store = safeStorage("local")

export default {
  mounted() {
    this.syncPreference()
    this.handleEvent("epm_toggled", ({ show }) => {
      store.setItem("show_epm", show.toString())
    })
  },
  reconnected() {
    this.syncPreference()
  },
  syncPreference() {
    const saved = store.getItem("show_epm")
    return pushHookEvent(this, "set_epm_preference", {show: saved === null ? true : saved === "true"})
  }
}
